import React from 'react'
import Styles from './styles.module.sass';

const SectionLayout = ({children, title, action}) => {

    return(
        <div className={Styles?.contentModulesLayout}>
            {title &&
                <div className={Styles?.boxSelectPeriodo}>
                    <div className={Styles?.tituloPage}>
                        <h1>{title}</h1>
                    </div>
                    {action && 
                        <div className={Styles?.actionModule}>
                            {action}
                        </div>
                    }
                </div>
            }
            { children }
        </div>
    )
}

export default SectionLayout